import { SelectOption } from '../components/Select';

const futureSaleOptions: Array<SelectOption<number>> = [
    { label: 'Sim', value: 1 },
    { label: 'Não', value: 0 },
];

export default futureSaleOptions;
